import { render } from "./IconXai.vue?vue&type=template&id=82a8174c"
import script from "./IconXai.vue?vue&type=script&lang=js"
export * from "./IconXai.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__